/**
 * 簡化版多國語言管理器 - 最小化影響現有功能
 */

export type Language = 'zh-TW' | 'en-US' | 'ja-JP';

interface Translations {
  [key: string]: string;
}

export class SimpleI18n {
  private static instance: SimpleI18n;
  private currentLanguage: Language = 'zh-TW';
  private translations: Map<Language, Translations> = new Map();
  private isInitialized = false;

  // 內建翻譯，避免載入失敗
  private builtInTranslations: Record<Language, Translations> = {
    'zh-TW': {
      'Battle Pass': 'Battle Pass',
      '購買PASS': '購買PASS',
      '一鍵領取': '一鍵領取',
      '領取中...': '領取中...',
      '更新中...': '更新中...',
      '獎勵': '獎勵',
      '任務': '每日任務',
      '免費獎勵': '免費獎勵',
      'SWAG Pass 獎勵': '鑽石獎勵',
      '等級': '等級',
      '前往': '前往',
      '領取星星': '領取星星',
      '已完成': '已完成',
      'd': '天',
      'h': '小時',
      'm': '分鐘',
      // 任務描述（根據 @daily-tasks.md，包含目標）
      '領取登入獎勵': '領取登入獎勵',
      '累計觀看直播5分鐘': '觀看直播累積 5 分鐘',
      '累計消費1000鑽石': '使用鑽石累積達 1,000 鑽(不包含直播間遊戲下注)',
      '在任何直播間傳送一則訊息': '於任意直播間內發言互動',
      '在任何直播間送出一個禮物': '於直播間內贈送任意禮物',
      '在私訊或群聊中傳送訊息或禮物': '於聊天室內使用鑽石對話或贈送任意禮物',
      '解鎖任何付費限時動態或貼文': '解鎖限時動態或貼文 1 則',
      '完成一筆鑽石購買': '購買任意金額的鑽石商品',
      '觀看5則不同的短影片': '看短影音 5 則',
      '在直播間使用一次指令或玩具': '玩直播間指令、遙控玩具',
      '在直播間玩一場遊戲': '玩直播間任一遊戲（龍虎鬥、一柱擎天等）',
      // 獎勵系統翻譯（根據 @battle-pass-system.md）
      '額外獎勵': '額外獎勵',
      '滿等後，每累積 500 積分可獲得下列獎勵': '滿等後，每累積 500 積分可獲得下列獎勵',
      '10分鐘直播暢遊券': '10分鐘直播暢遊券',
      '10分鐘長片觀看券': '10分鐘長片觀看券',
      '3分鐘直播暢遊券': '3分鐘直播暢遊券',
      '3分鐘長片觀看券': '3分鐘長片觀看券',
      '5分鐘直播暢遊券': '5分鐘直播暢遊券',
      '5分鐘長片觀看券': '5分鐘長片觀看券',
      // 額外獎勵狀態文字
      '需達到': '需達到',
      '級': '級',
      '可領取': '可領取',
      '次': '次',
      '還需': '還需',
      '積分': '積分',
      '已達成條件': '已達成條件',
      // 額外獎勵區域的翻譯
      '已領取次數': '已領取次數',
      '請使用上方「一鍵領取」按鈕領取': '請使用上方「一鍵領取」按鈕領取',
      // 通知訊息翻譯
      '此獎勵已經領取過了': '此獎勵已經領取過了',
      '此任務已經完成了': '此任務已經完成了',
      '等級不足，無法領取此獎勵': '等級不足',
      '等級不足，請先完成任務提升等級': '等級不足，請先完成任務',
      '沒有可領取的獎勵': '沒有可領取的獎勵',
      '獎勵領取失敗，請稍後再試': '獎勵領取失敗',
      '沒有成功領取任何獎勵': '領取失敗',
      '服務未初始化，請重新載入頁面': '服務未初始化',
      '數據更新失敗': '數據更新失敗',
      '更新進度失敗，請稍後再試': '更新失敗',
      '無法開啟任務頁面，請手動前往': '無法開啟頁面',
      '此任務暫無跳轉頁面': '暫無跳轉頁面',
      '無法開啟購買頁面，請手動前往 SWAG 官網購買': '無法開啟購買頁面',
      '部分獎勵領取成功，請檢查獎勵狀態': '部分獎勵領取成功',
      // 購買對話框翻譯
      '購買 Battle Pass': '購買 Battle Pass',
      '20,000 鑽 價值 NT$ 1499 ，6折優惠帶走！': '購買即可解鎖對應等級的鑽石獎勵，\n累積最高可得 20,000 鑽，原價 NT$ 1499，\n現在 6 折優惠帶走！\n(*購買後需在賽季內持續升級取得鑽石)',
      'NT$ 599': 'NT$ 599',
      '取消': '取消',
      '購買': '購買',
      'Battle Pass 購買成功！': 'Battle Pass 購買成功！',
      '您已經購買過 Battle Pass！': '您已經購買過 Battle Pass！',
      '本期 Battle Pass 您已經擁有了，無需重複購買。': '本期 Battle Pass 您已經擁有了，無需重複購買。',
      '確定': '確定',
      '處理中...': '處理中...',
      '購買失敗，請稍後再試': '購買失敗，請稍後再試',
      
      // 注意事項彈窗翻譯
      '注意事項': '注意事項',
      '任務重置時間為每日 08:00AM (GMT+8)，請於時間內完成任務': '任務重置時間為每日 08:00AM (GMT+8)，請於時間內完成任務',
      '任務重置時間為每日 8:00AM (GMT+8)，請於時間內完成任務': '任務重置時間為每日 00:00AM (GMT+8)，請於時間內完成任務',
      '新賽季於每月 1 號 08:00AM(GMT+8) 開始，請留意賽季結束時間': '新賽季於每月 1 號 08:00AM(GMT+8) 開始，請留意賽季結束時間',
    },
    'en-US': {
      'Battle Pass': 'Battle Pass',
      '購買PASS': 'BUY PASS',
      '一鍵領取': 'GET ALL',
      '領取中...': 'CLAIMING...',
      '更新中...': 'UPDATING...',
      '更新進度': 'REFRESH',
      '獎勵': 'Rewards',
      '任務': 'Daily Tasks',
      '免費獎勵': 'Free Rewards',
      'SWAG Pass 獎勵': 'Diamond Rewards',
      '等級': 'Level',
      '前往': 'GO',
      '領取星星': 'CLAIM STARS',
      '已完成': 'COMPLETED',
      'd': 'd',
      'h': 'h',
      'm': 'm',
      // 任務描述英文翻譯（包含目標）
      '領取登入獎勵': 'Claim daily login reward',
      '累計觀看直播5分鐘': 'Watch streams for 5 minutes',
      '累計消費1000鑽石': 'Use diamonds totaling 1,000 (excluding stream game bets)',
      '在任何直播間傳送一則訊息': 'Send a message in any stream',
      '在任何直播間送出一個禮物': 'Send a gift in any stream',
      '在私訊或群聊中傳送訊息或禮物': 'Send message or gift using diamonds in chat',
      '解鎖任何付費限時動態或貼文': 'Unlock 1 premium post or story',
      '完成一筆鑽石購買': 'Purchase any diamond package',
      '觀看5則不同的短影片': 'Watch 5 short videos',
      '在直播間使用一次指令或玩具': 'Use stream commands or toys',
      '在直播間玩一場遊戲': 'Play stream games',
      // 獎勵系統英文翻譯
      '額外獎勵': 'Extra Bonus',
      '滿等後，每累積 500 積分可獲得下列獎勵': 'After reaching max level, earn rewards for every 500 points',
      '10分鐘直播暢遊券': '10-min Stream Pass',
      '10分鐘長片觀看券': '10-min Video Pass',
      '3分鐘直播暢遊券': '3-min Stream Pass',
      '3分鐘長片觀看券': '3-min Video Pass',
      '5分鐘直播暢遊券': '5-min Stream Pass',
      '5分鐘長片觀看券': '5-min Video Pass',
      // 額外獎勵狀態文字英文翻譯
      '需達到': 'Reach level',
      '級': '',
      '可領取': 'Available:',
      '次': 'times',
      '還需': 'Need',
      '積分': 'more points',
      '已達成條件': 'Condition met',
      // 額外獎勵區域的英文翻譯
      '已領取次數': 'Claimed:',
      '請使用上方「一鍵領取」按鈕領取': 'Use "Claim All" button above',
      // 通知訊息英文翻譯
      '此獎勵已經領取過了': 'Already claimed',
      '此任務已經完成了': 'Task completed',
      '等級不足，無法領取此獎勵': 'Level too low',
      '等級不足，請先完成任務提升等級': 'Level too low, complete tasks first',
      '沒有可領取的獎勵': 'No rewards available',
      '獎勵領取失敗，請稍後再試': 'Claim failed',
      '沒有成功領取任何獎勵': 'Claim failed',
      '服務未初始化，請重新載入頁面': 'Service not initialized',
      '數據更新失敗': 'Data update failed',
      '更新進度失敗，請稍後再試': 'Update failed',
      '無法開啟任務頁面，請手動前往': 'Cannot open page',
      '此任務暫無跳轉頁面': 'No redirect page',
      '無法開啟購買頁面，請手動前往 SWAG 官網購買': 'Cannot open purchase page',
      '部分獎勵領取成功，請檢查獎勵狀態': 'Partial success',
      // 購買對話框英文翻譯
      '購買 Battle Pass': 'Purchase Battle Pass',
      '20,000 鑽 價值 NT$ 1499 ，6折優惠帶走！': 'Purchase to unlock corresponding level diamond rewards,\nEarn up to 20,000 diamonds total, originally NT$ 1499,\nNow 40% off!\n(*Continuous leveling required after purchase to obtain diamonds)',
      'NT$ 599': 'NT$ 599',
      '取消': 'Cancel',
      '購買': 'Purchase',
      'Battle Pass 購買成功！': 'Battle Pass purchased successfully!',
      '您已經購買過 Battle Pass！': 'You already own Battle Pass!',
      '本期 Battle Pass 您已經擁有了，無需重複購買。': 'You already own this season\'s Battle Pass, no need to purchase again.',
      '確定': 'OK',
      '處理中...': 'Processing...',
      '購買失敗，請稍後再試': 'Purchase failed, please try again later',
      
      // 注意事項彈窗翻譯
      '注意事項': 'Important Notes',
      '任務重置時間為每日 08:00AM (GMT+8)，請於時間內完成任務': 'Daily tasks reset at 08:00AM (GMT+8). Please complete tasks within the time limit',
      '任務重置時間為每日 8:00AM (GMT+8)，請於時間內完成任務': 'Daily tasks reset at 00:00AM (GMT+8). Please complete tasks within the time limit',
      '新賽季於每月 1 號 08:00AM(GMT+8) 開始，請留意賽季結束時間': 'New seasons start on the 1st of each month at 08:00AM (GMT+8). Please note the season end time',
      '完成任務可獲得「星星」，滿 150 顆星星升級 1 等，可獲得該等級獎勵，60等後不會升等，但可持續累積星星獲取額外獎勵': 'Completing tasks earns "Stars". Collect 150 stars to level up once and claim level rewards. After level 60, no more leveling up, but stars continue to accumulate for extra rewards',
      '完成任務後約有 10-20 秒更新時間，可再次打開頁面或按任務的「更新進度」刷新狀態，頻繁刷新可能導致頁面讀取失敗，請 1 分鐘後再嘗試': 'Tasks take 10-20 seconds to update. You can reopen the page or click "Update Progress" to refresh. Frequent refreshing may cause loading failures, please wait 1 minute before retrying',
      '進行任務內觀看直播滿 5 分鐘，請務必正常離開直播間才會納入計算': 'For the 5-minute stream viewing task, you must exit the stream room normally for it to count',
      '獎勵領取一律請點擊「一鍵領取」按鈕取得，後方數字代表獎勵等級數量，非物品數量': 'To claim rewards, use the "Claim All" button. The number represents reward levels, not individual items',
      '請於賽季結束前務必將獎勵領取完畢，新賽季開始時如未領取上一賽季獎勵，將不予補發': 'Please claim all rewards before the season ends. Unclaimed rewards from the previous season will not be reissued when the new season begins',
      '直播券與影片券請至背包內使用，皆有效期，請留意過期時間': 'Livestream and video vouchers can be used in your inventory. All have expiration dates, please check expiry times'
    },
    'ja-JP': {
      'Battle Pass': 'Battle Pass',
      '購買PASS': 'パス購入',
      '一鍵領取': '一括受取',
      '領取中...': '受取中...',
      '更新中...': '更新中...',
      '更新進度': '進捗更新',
      '獎勵': '報酬',
      '任務': 'デイリータスク',
      '免費獎勵': '無料報酬',
      'SWAG Pass 獎勵': 'ダイヤモンド報酬',
      '等級': 'レベル',
      '前往': '移動',
      '領取星星': 'スター受取',
      '已完成': '完了',
      'd': '日',
      'h': '時間',
      'm': '分',
      // 任務描述日文翻譯（包含目標）
      '領取登入獎勵': 'ログインボーナスを受け取る',
      '累計觀看直播5分鐘': '配信を5分間視聴する',
      '累計消費1000鑽石': 'ダイヤモンド使用累計1,000個(配信ゲームベット除く)',
      '在任何直播間傳送一則訊息': '配信でメッセージを送る',
      '在任何直播間送出一個禮物': '配信でギフトを送る',
      '在私訊或群聊中傳送訊息或禮物': 'チャットでダイヤを使ってメッセージやギフトを送る',
      '解鎖任何付費限時動態或貼文': 'プレミアム投稿を1つアンロックする',
      '完成一筆鑽石購買': 'ダイヤパッケージを購入する',
      '觀看5則不同的短影片': 'ショート動画を5本見る',
      '在直播間使用一次指令或玩具': '配信でコマンドやおもちゃを使う',
      '在直播間玩一場遊戲': '配信でゲームをプレイする',
      // 獎勵系統日文翻譯
      '額外獎勵': 'エクストラボーナス',
      '滿等後，每累積 500 積分可獲得下列獎勵': 'レベルマックス後、500ポイント毎に以下の報酬を獲得',
      '10分鐘直播暢遊券': '10分配信パス',
      '10分鐘長片觀看券': '10分動画パス',
      '3分鐘直播暢遊券': '3分配信パス',
      '3分鐘長片觀看券': '3分動画パス',
      '5分鐘直播暢遊券': '5分配信パス',
      '5分鐘長片觀看券': '5分動画パス',
      // 額外獎勵狀態文字日文翻譯
      '需達到': 'レベル',
      '級': 'に到達が必要',
      '可領取': '受取可能:',
      '次': '回',
      '還需': 'あと',
      '積分': 'ポイント必要',
      '已達成條件': '条件達成',
      // 額外獎勵區域的日文翻譯
      '已領取次數': '受取済み:',
      '請使用上方「一鍵領取」按鈕領取': '上の「一括受取」ボタンを使用してください',
      // 通知訊息日文翻譯
      '此獎勵已經領取過了': '受取済みです',
      '此任務已經完成了': 'タスク完了',
      '等級不足，無法領取此獎勵': 'レベル不足',
      '等級不足，請先完成任務提升等級': 'レベル不足、タスクを完了してください',
      '沒有可領取的獎勵': '受取可能な報酬なし',
      '獎勵領取失敗，請稍後再試': '受取失敗',
      '沒有成功領取任何獎勵': '受取失敗',
      '服務未初始化，請重新載入頁面': 'サービス未初期化',
      '數據更新失敗': 'データ更新失敗',
      '更新進度失敗，請稍後再試': '更新失敗',
      '無法開啟任務頁面，請手動前往': 'ページを開けません',
      '此任務暫無跳轉頁面': 'リダイレクトページなし',
      '無法開啟購買頁面，請手動前往 SWAG 官網購買': '購入ページを開けません',
      '部分獎勵領取成功，請檢查獎勵狀態': '一部成功',
      // 購買對話框日文翻譯
      '購買 Battle Pass': 'Battle Pass購入',
      '20,000 鑽 價值 NT$ 1499 ，6折優惠帶走！': '購入で対応レベルのダイヤモンド報酬をアンロック、\n最大20,000ダイヤ獲得可能、定価NT$ 1499、\n今なら40%オフ！\n(*購入後はシーズン内で継続的にレベルアップしてダイヤを獲得)',
      'NT$ 599': 'NT$ 599',
      '取消': 'キャンセル',
      '購買': '購入',
      'Battle Pass 購買成功！': 'Battle Pass購入成功！',
      '您已經購買過 Battle Pass！': 'Battle Passを既に購入済みです！',
      '本期 Battle Pass 您已經擁有了，無需重複購買。': '今期のBattle Passは既にお持ちです。重複購入は不要です。',
      '確定': 'OK',
      '處理中...': '処理中...',
      '購買失敗，請稍後再試': '購入に失敗しました。後でもう一度お試しください。',
      
      // 注意事項彈窗翻譯
      '注意事項': '注意事項',
      '任務重置時間為每日 08:00AM (GMT+8)，請於時間內完成任務': '毎日のタスクは08:00AM (GMT+8)にリセットされます。時間内にタスクを完了してください',
      '任務重置時間為每日 8:00AM (GMT+8)，請於時間內完成任務': '毎日のタスクは00:00AM (GMT+8)にリセットされます。時間内にタスクを完了してください',
      '新賽季於每月 1 號 08:00AM(GMT+8) 開始，請留意賽季結束時間': '新シーズンは毎月1日の08:00AM(GMT+8)に開始します。シーズン終了時間にご注意ください',
      '完成任務可獲得「星星」，滿 150 顆星星升級 1 等，可獲得該等級獎勵，60等後不會升等，但可持續累積星星獲取額外獎勵': 'タスク完了で「スター」獲得。150個で1レベルアップし、レベル報酬を獲得。レベル60以降はレベルアップしませんが、スターは追加報酬のため蓄積され続けます',
      '完成任務後約有 10-20 秒更新時間，可再次打開頁面或按任務的「更新進度」刷新狀態，頻繁刷新可能導致頁面讀取失敗，請 1 分鐘後再嘗試': 'タスク完了後10-20秒の更新時間があります。ページを再度開くか「進捗更新」をクリックしてください。頻繁な更新は読み込み失敗の原因となるため、1分後に再試行してください',
      '進行任務內觀看直播滿 5 分鐘，請務必正常離開直播間才會納入計算': '5分間の配信視聴タスクでは、正常に配信ルームを退出することでカウントされます',
      '獎勵領取一律請點擊「一鍵領取」按鈕取得，後方數字代表獎勵等級數量，非物品數量': '報酬受取は「一括受取」ボタンを使用。数字は報酬レベル数でアイテム数ではありません',
      '請於賽季結束前務必將獎勵領取完畢，新賽季開始時如未領取上一賽季獎勵，將不予補發': 'シーズン終了前にすべての報酬を受け取ってください。新シーズン開始時に前シーズンの未受取報酬は再発行されません',
      '直播券與影片券請至背包內使用，皆有效期，請留意過期時間': 'ライブ配信券と動画券はインベントリで使用できます。すべて有効期限がありますので、期限にご注意ください'
    }
  };

  private constructor() {
    this.detectLanguage();
    this.loadBuiltInTranslations();
  }

  public static getInstance(): SimpleI18n {
    if (!SimpleI18n.instance) {
      SimpleI18n.instance = new SimpleI18n();
    }
    return SimpleI18n.instance;
  }

  private detectLanguage(): void {
    // 1. URL 參數
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang') as Language;
    if (langParam && this.isValidLanguage(langParam)) {
      this.currentLanguage = langParam;
      return;
    }

    // 2. localStorage
    const savedLang = localStorage.getItem('battlepass_language') as Language;
    if (savedLang && this.isValidLanguage(savedLang)) {
      this.currentLanguage = savedLang;
      return;
    }

    // 3. 瀏覽器語言
    const browserLang = navigator.language;
    if (browserLang.startsWith('en')) {
      this.currentLanguage = 'en-US';
    } else if (browserLang.startsWith('ja')) {
      this.currentLanguage = 'ja-JP';
    }
  }

  private isValidLanguage(lang: string): lang is Language {
    return ['zh-TW', 'en-US', 'ja-JP'].includes(lang as Language);
  }

  private loadBuiltInTranslations(): void {
    Object.entries(this.builtInTranslations).forEach(([lang, translations]) => {
      this.translations.set(lang as Language, translations);
    });
    this.isInitialized = true;
  }

  public setLanguage(language: Language): void {
    if (!this.isValidLanguage(language)) return;
    
    this.currentLanguage = language;
    localStorage.setItem('battlepass_language', language);
    
    // 觸發語言變更事件，讓其他組件重新渲染動態內容
    window.dispatchEvent(new CustomEvent('languageChanged', { 
      detail: { language: this.currentLanguage } 
    }));
  }

  public getCurrentLanguage(): Language {
    return this.currentLanguage;
  }

  public translate(text: string): string {
    if (!this.isInitialized) return text;
    
    const translations = this.translations.get(this.currentLanguage);
    // 🔧 修正：正確處理空字串翻譯，不要 fallback 到原文
    return translations?.[text] !== undefined ? translations[text] : text;
  }

  public updatePageTexts(): void {
    if (!this.isInitialized) return;

    // 定義需要翻譯的選擇器和文字映射
    const textMappings = [
      { selector: '.bp-title', text: 'Battle Pass' },
      { selector: '.premium-pass-button .button-text', text: '購買PASS' },
      { selector: '.pass-level-claim .button-text', text: '一鍵領取' },
      { selector: '.task-refresh-button .button-text', text: '更新進度' },
      { selector: '.tab-button:first-child', text: '獎勵', preserveChildren: true },
      { selector: '.tab-button:last-child', text: '任務', preserveChildren: true },
      { selector: '.rewards-title.free', text: '免費獎勵', childIndex: 1 },
      { selector: '.rewards-title.level', text: '等級' },
      { selector: '.rewards-title.premium', text: 'SWAG Pass 獎勵', childIndex: 1 },
      
      // 注意事項彈窗翻譯
      { selector: '#info-modal-title', text: '注意事項' },
      { selector: '.info-list li:nth-child(1)', text: '任務重置時間為每日 08:00AM (GMT+8)，請於時間內完成任務' },
      { selector: '.info-list li:nth-child(2)', text: '完成任務可獲得「星星」，滿 150 顆星星升級 1 等，可獲得該等級獎勵，60等後不會升等，但可持續累積星星獲取額外獎勵' },
      { selector: '.info-list li:nth-child(3)', text: '完成任務後約有 10-20 秒更新時間，可再次打開頁面或按任務的「更新進度」刷新狀態，頻繁刷新可能導致頁面讀取失敗，請 1 分鐘後再嘗試' },
      { selector: '.info-list li:nth-child(4)', text: '進行任務內觀看直播滿 5 分鐘，請務必正常離開直播間才會納入計算' },
      { selector: '.info-list li:nth-child(5)', text: '獎勵領取一律請點擊「一鍵領取」按鈕取得，後方數字代表獎勵等級數量，非物品數量' },
      { selector: '.info-list li:nth-child(6)', text: '請於賽季結束前務必將獎勵領取完畢，新賽季開始時如未領取上一賽季獎勵，將不予補發' },
      { selector: '.info-list li:nth-child(7)', text: '新賽季於每月 1 號 08:00AM(GMT+8) 開始，請留意賽季結束時間' },
      { selector: '.info-list li:nth-child(8)', text: '直播券與影片券請至背包內使用，皆有效期，請留意過期時間' }
    ];

    textMappings.forEach(mapping => {
      const elements = document.querySelectorAll(mapping.selector);
      elements.forEach(element => {
        const translatedText = this.translate(mapping.text);
        console.log(`[SimpleI18n] 翻譯 "${mapping.text}" → "${translatedText}" (選擇器: ${mapping.selector})`);
        
        if (typeof mapping.childIndex === 'number') {
          // 更新特定子節點的文字 - 尋找第一個非空文字節點
          let textNode = null;
          let textNodeIndex = -1;
          
          for (let i = 0; i < element.childNodes.length; i++) {
            const node = element.childNodes[i];
            if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
              textNode = node;
              textNodeIndex = i;
              break;
            }
          }
          
          console.log(`[SimpleI18n] 尋找文字節點 (期望索引 ${mapping.childIndex}, 實際索引 ${textNodeIndex}):`, textNode, '文字內容:', textNode?.textContent?.trim());
          
          if (textNode && textNode.nodeType === Node.TEXT_NODE) {
            textNode.textContent = translatedText;
            console.log(`[SimpleI18n] 已更新子節點文字: "${translatedText}"`);
          } else {
            console.warn(`[SimpleI18n] 找不到有效的文字節點`, { element, expectedChildIndex: mapping.childIndex, actualIndex: textNodeIndex, allChildNodes: Array.from(element.childNodes).map(n => ({ type: n.nodeType, content: n.textContent })) });
          }
        } else if ((mapping as any).preserveChildren) {
          // 保留子元素，只更新第一個文字節點
          this.updateTextPreservingChildren(element, translatedText);
        } else {
          // 安全地更新文字內容，保留子元素
          this.updateTextSafely(element, translatedText);
        }
      });
    });

    // 更新倒計時單位
    this.updateCountdownUnits();
    
    // 更新動態生成的按鈕文字（任務列表中的按鈕）
    this.updateDynamicButtons();
  }

  private updateCountdownUnits(): void {
    const daysSpan = document.querySelector('.countdown-timer .days');
    const hoursSpan = document.querySelector('.countdown-timer .hours');
    const minutesSpan = document.querySelector('.countdown-timer .minutes');

    if (daysSpan?.nextSibling) {
      daysSpan.nextSibling.textContent = this.translate('d') + ' ';
    }
    if (hoursSpan?.nextSibling) {
      hoursSpan.nextSibling.textContent = this.translate('h') + ' ';
    }
    if (minutesSpan?.nextSibling) {
      minutesSpan.nextSibling.textContent = this.translate('m');
    }
  }

  private updateDynamicButtons(): void {
    // 更新任務列表中的按鈕
    const taskButtons = document.querySelectorAll('.task-item .go-button');
    taskButtons.forEach(button => {
      const currentText = button.textContent?.trim();
      if (currentText === '前往' || currentText === 'GO' || currentText === '移動') {
        button.textContent = this.translate('前往');
      } else if (currentText === '領取星星' || currentText === 'CLAIM STARS' || currentText === 'スター受取' || currentText === '領取獎勵' || currentText === 'CLAIM' || currentText === '受け取る') {
        button.textContent = this.translate('領取星星');
      } else if (currentText === '已完成' || currentText === 'COMPLETED' || currentText === '完了' || currentText === '已領取' || currentText === 'CLAIMED' || currentText === '受取済') {
        button.textContent = this.translate('已完成');
      }
    });
  }

  /**
   * 安全地更新元素的文字內容，保留子元素
   */
  private updateTextSafely(element: Element, newText: string): void {
    // 如果元素只有文字內容，直接更新
    if (element.childNodes.length === 1 && element.childNodes[0].nodeType === Node.TEXT_NODE) {
      element.textContent = newText;
      return;
    }

    // 如果元素有子元素，只更新第一個文字節點
    for (let i = 0; i < element.childNodes.length; i++) {
      const node = element.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
        node.textContent = newText;
        return;
      }
    }

    // 如果沒有找到文字節點，在開頭插入一個
    element.insertBefore(document.createTextNode(newText + ' '), element.firstChild);
  }

  /**
   * 更新文字但保留所有子元素（用於標籤頁按鈕）
   */
  private updateTextPreservingChildren(element: Element, newText: string): void {
    // 找到第一個文字節點並更新
    for (let i = 0; i < element.childNodes.length; i++) {
      const node = element.childNodes[i];
      if (node.nodeType === Node.TEXT_NODE) {
        const trimmedText = node.textContent?.trim();
        if (trimmedText && trimmedText !== '') {
          // 保持原有的空白格式
          const leadingSpace = node.textContent?.match(/^\s*/)?.[0] || '';
          const trailingSpace = node.textContent?.match(/\s*$/)?.[0] || '';
          node.textContent = leadingSpace + newText + trailingSpace;
          return;
        }
      }
    }

    // 如果沒有找到文字節點，在第一個子元素前插入
    const firstChild = element.firstChild;
    if (firstChild) {
      element.insertBefore(document.createTextNode(newText + '\n          '), firstChild);
    } else {
      element.appendChild(document.createTextNode(newText));
    }
  }

  public getSupportedLanguages(): Array<{ code: Language; name: string; flag: string }> {
    return [
      { code: 'zh-TW', name: '繁體中文', flag: '🇹🇼' },
      { code: 'en-US', name: 'English', flag: '🇺🇸' },
      { code: 'ja-JP', name: '日本語', flag: '🇯🇵' }
    ];
  }
}
